import defaultAttributes from '../defaultAttributes';

const Gitlab = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d:
          'M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 014.82 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0118.6 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.51L23 13.45a.84.84 0 01-.35.94z',
      },
    ],
  ],
];

export default Gitlab;
